import { DELETE_TYPE, GENDER } from '@/utils/enum';
import BaseModel from './Base.model';
import UserModel from './User.model';
import { OrderCanNotServeProductModel } from './OrderCanNotServeProduct.model';

export class OrderCanNotServeModel extends BaseModel {
  constructor(data = {}) {
    super({
      id: data.id || null,
      createdAt: data.createdAt || null,
      updatedAt: data.updatedAt || null,
    });

    this.customerId = data.customerId || null;
    this.customerName = data.customerName || '';
    this.customerPhone = data.customerPhone || '';
    this.customerAddress = data.customerAddress || '';
    this.gender = data.gender !== undefined ? data.gender : GENDER.OTHER;
    this.employeeId = data.employeeId || null;
    this.description = data.description || '';
    this.status = data.status || 0;
    this.deleted = data.deleted || DELETE_TYPE.AVAILABLE;
    this.storeId = data.storeId || null;
    this.createdBy = data.createdBy || null;
    this.updatedBy = data.updatedBy || null;

    // Relations
    this.employee = UserModel.fromJson(data.employee || {});
    this.creator = UserModel.fromJson(data.creator || {});
    this.updater = UserModel.fromJson(data.updater || {});
    this.products = OrderCanNotServeProductModel.fromJsonArray(
      data.products || [],
    );

    // Additional computed fields
    this.store = data.store || null;
    this.storeName = data.store?.name || null;
    this.employeeName = this.employee?.fullName || null;
    this.storeName = this.store?.name || null;
  }

  static fromJson(data) {
    return BaseModel.fromJson(data, OrderCanNotServeModel);
  }

  static fromJsonArray(dataArray) {
    return BaseModel.fromJsonArray(dataArray, OrderCanNotServeModel);
  }
}
